import React from 'react';
import { useFieldAttributes } from '../../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../../sdk/components-wut';
import Fieldset from '../../../ui/fieldset';
import { MediaBoxSelectionWUT } from '../../../ui/media-box-selection/media-box-selection-wut';
import { NUMBER_OF_COLUMNS } from '../../../ui/options-layout/options-layout-constants';
export const ImageChoiceWUT = (props)=>{
    const { id, target, required = false, error, hasError = false, errorMessage, description, FieldLayout, label, hideLabel, value, onChange, options, numberOfColumns, choiceImageResize, onFocus, onBlur, requiredIndicatorType, requiredIndicatorPlacement, thumbnailWidth, additionalInfo } = props;
    const { inputId, labelId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    const columns = !numberOfColumns || numberOfColumns === NUMBER_OF_COLUMNS.ONE ? 'single' : numberOfColumns === NUMBER_OF_COLUMNS.TWO ? 'two' : 'three';
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(Fieldset, {
                id: inputId,
                ariaLabelledBy: labelId,
                ariaDescribedBy: ariaDescribedBy,
                onFocus: onFocus,
                onBlur: onBlur,
                required: required
            }, /*#__PURE__*/ React.createElement(MediaBoxSelectionWUT, {
                value: value,
                onChange: onChange,
                options: options,
                isMultipleAnswers: true,
                fit: choiceImageResize,
                columns: columns,
                thumbnailWidth: thumbnailWidth
            })),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }), additionalInfo)
    });
};

//# sourceMappingURL=image-choice-wut.js.map